module.exports = __webpack_public_path__ + "media/bj.41408bd9.mp3";